import React from "react";
import { Col, Row, Typography } from "antd";
import RevenueChart from "./components/RevenueChart";
import OverdueCollections from "./components/OverdueCollections";
import ContractsTimeline from "./components/ContractsTimeline";
import RevenueByPlan from "./components/RevenueByPlan";
import PlansWithDefault from "./components/PlansWithDefault";
import AverageTicketChart from "./components/AverageTicketChart";

const { Title } = Typography;

export default function Reports() {
  return (
    <div style={{ padding: 24 }}>
      <Title level={3}>Relatórios</Title>
      
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={16}>
          <RevenueChart />
        </Col>
        <Col xs={24} lg={8}>
          <OverdueCollections />
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <AverageTicketChart />
        </Col>
        <Col xs={24} lg={12}>
          <ContractsTimeline />
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <RevenueByPlan />
        </Col>
        <Col xs={24} lg={12}>
          <PlansWithDefault />
        </Col>
      </Row>
    </div>
  );
}
